import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCard,{attrs:{"elevation":"0"}},[_c(VCardTitle,[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t("groups.videos"))+" ")]),_c(VSpacer),(_vm.isManager)?_c('AddVideoButton',{attrs:{"group-id":_vm.groupId}}):_vm._e()],1),_c(VCardText,[_c('VideosList',{attrs:{"group":_vm.group}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }